export const documents = {
  title: "Dokumendid",
  description: "Halda ja vaata oma dokumente",
  newDocument: {
    trigger: "Uus dokument",
    title: "Uus dokument",
    searchPlaceholder: "Otsi malle…",
    listLabel: "Dokumendimallid",
    noResults: "Otsingule vastavaid malle ei leitud",
    noResultsHint: "Proovi teist sõna või tühjenda otsing, et näha kõiki malle.",
    aboutTemplate: "Malli kohta",
    sections: {
      franklin: "Franklini mallid",
    },
    templates: {
      coveredWorksAct: {
        name: "Kaetud tööde akt",
        fullName: "Kaetud tööde akt (Covered works act)",
        details:
          "Fikseerib tööd enne nende kinnikatmist, et seina taha või põranda alla jääv oleks tõendatud. Allkirjastatakse Franklinis digitaalselt ja trükitakse ametlikule kaetud tööde akti vormile.",
        description: "Fikseeri kaetavad tööd koos fotode ja need üle vaadanud osapooltega.",
      },
      constructionDiary: {
        name: "Ehituspäevik",
        fullName: "Ehituspäevik (Construction diary)",
        details:
          "Päeva ülevaade objektist — tehtud tööd, ilm, inimesed ja tarned. Trükitakse ametlikule ehituspäeviku vormile, üks nummerdatud lehekülg päevas.",
        description: "Igapäevane ülevaade töödest, ilmast, objektil olnud inimestest ja tarnetest.",
      },
      moreFranklinTemplates: {
        name: "Rohkem Franklini malle",
        fullName: "Rohkem Franklini malle",
        details:
          "Uued Franklini mallid on tulekul. See kaart on kohatäide ja seda ei saa veel avada.",
        description: "Uued Franklini mallid on tulekul.",
      },
    },
  },
  templateForm: {
    back: "Tagasi mallide juurde",
    preview: "Eelvaade",
    documentNumber: "Nr",
    documentNumberHint: "Number määratakse dokumendi salvestamisel.",
    documentName: "Dokumendi nimi",
    choosePrefilled: "Vali eeltäidetud vorm",
    importFrom: "Impordi",
    searchSavedForms: "Otsi salvestatud vorme…",
    noSavedForms: "Salvestatud vorme veel ei ole.",
    savedFormsNeedProject:
      "Salvestatud vormid kuuluvad projekti — selle dokumendi projekt valitakse alles salvestamisel, seega pole siin midagi pakkuda.",
    savedFormsProject: "Projekt",
    savedFormsPickProject: "Vali projekt, et näha selle juba täidetud vorme.",
    prefilledFrom: "Täidetud vormi {name} põhjal. Number ja nimi jäävad selle vormi omaks.",
    importedFrom: "{field} võetud vormist {name}.",
    importedNothing: "Vormil {name} ei ole selles väljas midagi.",
    addPerson: "Lisa isik",
    removePerson: "Eemalda isik",
    personName: "Nimi",
    personCompany: "Ettevõte",
    personCertificate: "Tunnistuse nr",
    personSigner: "Allkirjastaja",
    pickMember: "Vali liige",
    searchMembers: "Otsi liikmeid…",
    noMembers: "Liikmeid ei leitud.",
    loadingMembers: "Laen liikmeid…",
    membersError: "Liikmete laadimine ebaõnnestus.",
    retryMembers: "Proovi uuesti",
    membersNeedProject:
      "Liikmed kuuluvad projekti — selle dokumendi projekt valitakse alles salvestamisel. Kirjuta nimi käsitsi.",
    uploadFiles: "Laadi failid üles",
    chooseFromProject: "Vali fail projektist",
    loadingDocuments: "Laen dokumente…",
    documentsError: "Dokumentide laadimine ebaõnnestus.",
    removeAttachment: "Eemalda manus",
    noAttachments: "Ühtegi faili pole veel lisatud.",
    duplicatesSkipped: "{count} juba lisatud faili jäeti vahele.",
    time: {
      hours: "Tund",
      minutes: "Min",
      clear: "Tühjenda",
      placeholder: "--:--",
    },
    attachToPdf: "Lisa manused PDF-i ja digidokumenti",
    signDigitally: "Vorm allkirjastatakse digitaalselt",
    pdfLanguage: {
      label: "PDF-i keel",
      et: "Eesti keeles",
      en: "Inglise keeles",
    },
    outputHints: {
      attachToPdf:
        "Lisatud PDF-id ja fotod lisatakse loodavasse dokumenti lisalehtedena, nii et need liiguvad koos sellega — sealhulgas allkirjastatud konteinerisse. Failid, mida lehele joonistada ei saa (näiteks DWG-joonised või tabelid), jäävad vormil kirja ainult nimega ja salvestatakse eraldi dokumentidena. Märkimata jätmisel manuseid PDF-i ei lisata ega loetleta.",
      signDigitally:
        "Pärast salvestamist avaneb dokument allkirjastamiseks Smart-ID, Mobiil-ID või ID-kaardiga ja salvestatakse allkirjastatud .asice konteinerina. Allkirjastajaks märgitud isikud trükitakse vormi enda allkirjaploki alla.",
    },
    save: "Salvesta",
    saving: "Salvestan…",
    discard: {
      title: "Kas loobud vormist?",
      description: "Kõik sisestatu läheb kaotsi. Projekti pole veel midagi salvestatud.",
      confirm: "Loobu",
      cancel: "Jätka täitmist",
    },
    destination: {
      title: "Kuhu see dokument läheb?",
      description: "Vali projekt ja kaust, kuhu see esitada.",
      submit: "Salvesta siia",
    },
    saved: {
      title: "Vorm salvestatud",
      description: "{name} on nüüd selle projekti dokumentides.",
      attachmentsNotEmbedded:
        "Need failid on vormil kirjas, kuid neid ei saanud PDF-i sisse lisada: {names}",
    },
    saveFailed: {
      title: "Vormi salvestamine ebaõnnestus",
      steps: {
        number: "Selle numbri võttis teine dokument. Proovi uuesti salvestada.",
        reserve: "Dokumendi numbrit ei õnnestunud reserveerida.",
        attachments: "Manuseid ei õnnestunud üles laadida.",
        pdf: "PDF-i loomine ebaõnnestus.",
        file: "PDF-i salvestamine ebaõnnestus.",
        record: "Dokument salvestati, kuid vormi ei õnnestunud sellega siduda.",
      },
    },
    validation: {
      missingFields: "Veel täitmata: {fields}",
      missingName: "Anna dokumendile nimi.",
      noProject: "Sellel hoonel ei ole veel projekti. Loo projekt, enne kui dokumente esitad.",
      notReady: "Sinu konto laeb veel. Proovi hetke pärast uuesti.",
    },
    overwrite: {
      title: "Selle nimega dokument on juba olemas",
      description:
        "{name} on siia juba esitatud. Salvestamisel lisatakse see vorm selle uue versioonina ja praegune versioon ei ole enam see, mida inimesed näevad.",
      confirm: "Salvesta uue versioonina",
      cancel: "Muuda nime",
    },
    signing: {
      unavailable: "Digiallkirjastamine ei ole sinu organisatsioonis sisse lülitatud.",
      startTitle: "Valmis allkirjastamiseks",
      startDescription: "Vorm on salvestatud. Allkirjasta kohe või hiljem dokumentide nimekirjast.",
    },
    pdf: {
      numberLabels: {
        act: "Akti nr:",
        page: "LK nr :",
        document: "Dokumendi nr:",
      },
      date: "2. Kuupäev:",
      contractor: "1. Ehitusettevõtja",
      digitallySigned: "/allkirjastatud digitaalselt/",
      failed: "PDF-i loomine ebaõnnestus.",
      signatureColumns: {
        nameAndCompany: "Nimi, ettevõte",
        certificate: "Kutsetunnistus",
      },
      weatherGrid: {
        time: "Kellaaeg",
        temperature: "Temp",
      },
      additionalData: "Lisaandmed",
      // Transcribed from the official forms — these are the statutory row
      // labels and must not be reworded.
      rows: {
        siteAndContract: "Ehitise nimetus ja asukoht / Lepingu Nr.",
        worksDescription: "Kaetud töö nimetus ja paiknemine",
        conformityAssessment:
          "Põhjendatud hinnang kaetud töö vastavusele kehtivatele nõuetele ja ehitusprojektile",
        otherWorkData: "Vajadusel muud andmed tehtud töö kohta",
        inspectionMethod:
          "Kaetud töö kontrollimise läbiviimisel kasutatud meetodi või seadmete kirjeldus",
        inspectionTime: "Kaetud töö kontrollimise aeg",
        attachments: "Akti lisad",
        author: "Kande tegija nimi",
        weather: "Ilmastik",
        otherFactors: "Muud mõjutegurid\n(nt ruumi temperatuur, niiskus, keskkonnaolud)",
        worksPerformed: "Tehtud töö kirjeldus",
        materials: "Kasutatud ehitusmaterjalid ja -tooted",
        coveredWorksActs: "Kaetud tööde aktid",
        wasteRemovalDate: "Jäätmete äraveo kuupäev",
        supervisorNote: "Omanikujärelevalve tegija märkus või soovitus selle olemasolul",
        stateSupervisionOrder: "Riikliku järelevalve teostaja ettekirjutus selle olemasolul",
        contractorSignatories: "Ehitustöö tegija ja tema pädeva isiku nimi",
        supervisorSignatories: "Omanikujärelevalve tegija ja tema pädeva isiku nimi",
      },
    },
    sections: {
      general: { title: "Üldandmed" },
      coveredWorks: {
        title: "Kaetud tööd",
        help: "Kirjelda kaetavad tööd, nende asukoht ja nõuded, millele need vastavad.",
      },
      conditions: { title: "Tingimused", help: "Ilmastik ja olud ülevaatuse hetkel." },
      diaryWorks: { title: "Tehtud tööd", help: "Mis objektil täna toimus." },
      diaryNotes: { title: "Märkused" },
      parties: {
        title: "Osapooled",
        help: "Kõik osalenud. Märgi, kes dokumendi allkirjastab.",
      },
      attachments: {
        title: "Manused",
        help: "Fotod, mõõtmised ja muud vormi juurde kuuluvad failid.",
      },
    },
    fields: {
      date: "Kuupäev",
      buildingName: "Hoone",
      buildingAddress: "Aadress",
      contractNumber: "Lepingu number",
      organisation: "Organisatsioon",
      author: "Kande autor",
      worksDescription: "Kaetud töö nimetus ja paiknemine",
      conformityAssessment: "Hinnang vastavusele",
      otherWorkData: "Muud andmed tehtud töö kohta",
      inspectionMethod: "Kontrollimise meetod või seadmed",
      otherFactors: "Muud mõjutegurid",
      coveredWorksActs: "Kaetud tööde aktid",
      wasteRemovalDate: "Jäätmete äraveo kuupäev",
      supervisorNote: "Omanikujärelevalve märkus",
      stateSupervisionOrder: "Riikliku järelevalve ettekirjutus",
      contractorSignatories: "Ehitustöö tegija",
      supervisorSignatories: "Omanikujärelevalve tegija",
      worksLocation: "Asukoht objektil",
      worksStart: "Tööde algus",
      worksEnd: "Tööde lõpp",
      materials: "Kasutatud materjalid",
      standards: "Normid ja nõuded",
      weather: "Ilm",
      temperature: "Temperatuur (°C)",
      inspectionTime: "Kellaaeg",
      worksPerformed: "Tehtud tööd",
      workforce: "Inimesi objektil",
      machinery: "Tehnika",
      deliveries: "Tarned",
      notes: "Märkused",
      instructions: "Antud juhised",
      attachments: "Manused",
    },
    weather: {
      strongWind: "Tugev tuul",
      dry: "Kuiv",
      rain: "Vihm",
      sleet: "Lörts",
      snow: "Lumi",
    },
  },
  list: {
    title: "Dokumentide nimekiri",
    name: "Dokument",
    description: "Dokumendi kirjeldus",
    type: "Tüüp",
    size: "Suurus",
    uploadDate: "Üleslaadimise kuupäev",
    version: "Versioon",
    actions: "Tegevused",
    search: "Otsi dokumente...",
    noDocuments: "Ükski dokument ei vasta otsingule",
    noFilterMatch:
      "Aktuaalsetele filtritele vastavaid dokumente ei leitud. Proovige filtreid muuta.",
    error: "Viga dokumentide laadimisel",
    select: "Vali",
    date: "Loomise kuupäev",
    versions: "versiooni",
  },
  upload: {
    title: "Lae dokumendid üles",
    button: "Lae üles",
    dragAndDrop: "Lohista failid siia või klõpsa failide valimiseks",
    multipleAllowed: "Lubatud on mitu faili",
    maxSize: "Maksimaalne failisuurus: 50MB",
    uploadSuccess: "Üleslaadimine õnnestus",
    uploadError: "Üleslaadimine ebaõnnestus",
    success: "Üleslaadimine õnnestus",
    successMessage: "Dokument on edukalt üles laaditud",
    dataExtracted: "Andmed ekstrakti",
    dataExtractedMessage: "Andmed on dokumendist ekstraktitud",
    currentCategory: "Praegune kategooria",
    currentFolder: "Praegune kaust",
    selectMode: "Vali üleslaadimise režiim",
    singleFile: "Üks fail",
    multipleFiles: "Mitu faili",
    multipleDescription: "Vali mitu faili korraga üleslaadimiseks",
    selectFiles: "Vali failid",
    uploading: "Failide üleslaadimine",
    foldersUploaded: "Üles laaditud kaustu: {count}",
    folderCreationFailedTitle: "Kaustade loomine ebaõnnestus",
    folderCreationFailedDescription: "Midagi ei laaditud üles. {reason}",
  },
  actions: {
    download: "Lae alla",
    delete: "Kustuta",
    process: "Töötle",
    deleteSuccess: "Dokument on edukalt kustutatud",
    reanalyze: "Analüüsi uuesti",
    categorize: "Kategoriseeri",
    categorizeSuccess: "Dokument on edukalt kategoriseeritud",
    categorizedAs: "Kategoriseeritud kui",
    categorizeFailed: "Dokumendi kategoriseerimine ebaõnnestus",
    move: "Liiguta",
    moving: "Liigutamine...",
    moveSuccess: "Dokumendid edukalt liigutatud",
    movedTo: "liigutatud kausta",
    moveFailed: "Dokumentide liigutamine ebaõnnestus",
    clear: "Puhasta",
    sorting: "Sorteerimine",
    close: "Sulge",
    create: "Loo",
    upload: "Lae üles",
    view: "Vaata",
    back: "Tagasi",
    refreshSuccess: "Dokumendid värskendatud",
    deleteDocument: "Kustuta dokument",
    deleteDocumentTitle: "Kustuta dokument?",
    deleteDocumentConfirm:
      'Kas olete kindel, et soovite kustutada "{filename}"? Seda tegevust ei saa tagasi võtta.',
    deleteDocumentConfirmFallback:
      "Kas olete kindel, et soovite selle dokumendi kustutada? Seda tegevust ei saa tagasi võtta.",
    downloading: "Allalaadimine",
    downloadingFile: 'Allalaadimine "{filename}"...',
    preparingDownload: "Valmistatakse {count} faili allalaadimiseks...",
    copy: "Kopeeri",
  },
  category: {
    all: "Kõik",
    drawings: "Joonised",
    design_documents: "Projekti Dokumendid",
    contracts: "Lepingud",
    permits: "Load",
    certificates: "Sertifikaadid",
    reports: "Aruanded",
    invoices: "Arved",
    other: "Muu",
    unsorted: "Sorteerimata",
    documents: "Dokumendid",
  },
  categories: {
    all: "dokumendid",
    documents: "Dokumendid",
    drawings: "Joonised",
    unsorted: "Sorteerimata",
    predefinedFolders: "Eelmääratletud Kaustad",
  },
  status: {
    processing: "Dokumendi töötlemine",
    processingFailed: "Dokumenti ei õnnestunud töödelda",
    unsupportedFiletype: "Toetamata failitüüp",
    zipFile: "Zip-fail",
    teachFranklin: "Klõpsa Franklini õpetamiseks",
    editTags: "Muuda silte",
    addTags: "Lisa sildid",
  },
  preview: {
    unavailable: "PDF eelvaade pole saadaval",
    unavailableDesc:
      "Teie brauser ei suutnud seda PDF-i kuvada. Saate faili siiski alla laadida või uuel vahelehel avada.",
    dwgDisclaimer: "Eelvaate ekspordid on esitatud ainult viitena",
  },
  folder: {
    title: "Kaustad",
    create: "Loo kaust",
    name: "Kausta nimi",
    type: "Kausta tüüp",
    actions: "Tegevused",
    root: "Juur",
    noFolders: "Kaustu ei leitud",
    newFolder: "Uus kaust",
    rename: "Nimeta ümber",
    delete: "Kustuta",
    deleteFolder: "Kustuta kaust",
    deleteConfirm:
      "Kas olete kindel, et soovite selle kausta kustutada? Seda tegevust ei saa tagasi võtta.",
    deleteSuccess: "Kaust edukalt kustutatud",
    deleteError: "Kausta kustutamine ebaõnnestus",
    createError: "Kausta loomine ebaõnnestus",
    noDocuments: "See kaust on tühi",
    categories: {
      documents: "Dokumendid",
      drawings: "Joonised",
      unsorted: "Sorteerimata",
    },
    totalDocuments: "dokumenti",
    new: "Uus Kaust",
    uploadFiles: "Lae failid üles",
    documentCount: "{count} dokumenti",
    documentCountOne: "1 dokument",
    subfolderCount: "{count} alamkausta",
    createSubfolder: "Loo alamkaust",
    exportFolder: "Ekspordi kaust",
    shareFolder: "Jaga kausta",
    folderActions: "Kausta tegevused",
    dropHereToMove: "Lohista siia teisaldamiseks",
    releaseToMove: "Vabasta teisaldamiseks",
    draggingItems: "Teisaldate {count} üksust. Kukutage esiletõstetud kausta.",
  },
  uploadModal: {
    title: "Lae dokumendid üles",
    dragDropFiles: "Lohista failid siia",
    dropFilesHere: "Kukuta failid siia",
    orClickToBrowse: "või kliki sirvimiseks",
    uploadFiles: "Lae failid üles",
    uploadFolder: "Lae kaust üles",
    readFailed: "Valitud üksusi ei õnnestunud lugeda. Proovige uuesti.",
    uploadingTo: "Üleslaadimise asukoht",
    chooseDestination: "Vali üleslaadimise asukoht",
    changeDestination: "Muuda",
    destinationTitle: "Vali üleslaadimise asukoht",
    destinationDescription: "Vali kaust, kuhu failid lähevad, või jäta need projekti juurkausta.",
    destinationSubmit: "Kasuta seda kausta",
    filesReady: "{count} faili on üleslaadimiseks valmis",
    foldersReady: "{count} kausta on üleslaadimiseks valmis",
    upload: "Lae üles",
  },
  destinationPicker: {
    title: "Vali kaust",
    submit: "Lae siia üles",
    cancel: "Tühista",
    descriptionWithFile:
      "Vali, kuhu salvestada „{filename}“. Võid selle jätta ka projekti juurkausta.",
    description: "Vali projekt ja kaust. Võid faili jätta ka projekti juurkausta.",
    projectLabel: "Projekt",
    projectFallback: "Projekt",
    newProject: "Uus projekt",
    projectNamePlaceholder: "Projekti nimi",
    selectProject: "Vali projekt…",
    defaultProject: "(vaikimisi)",
    noFolders: "Kaustu veel pole",
    selectProjectToBrowse: "Kaustade sirvimiseks vali projekt",
    newFolderHere: "Uus kaust siia",
    folderNamePlaceholder: "Kausta nimi",
    inFolder: "Kaustas {path}",
    inSelectedFolder: "Valitud kaustas",
    inProjectRoot: "Projekti {project} juurkaustas",
    folderCreated: "Kaust loodud",
    folderCreateFailed: "Kausta loomine ebaõnnestus",
    contentsLoadFailed: "Kausta sisu laadimine ebaõnnestus.",
    tryAgain: "Proovi uuesti",
    loadingContents: "Kausta sisu laadimine",
    emptyFolder: "Tühi kaust — fail salvestatakse siia.",
    existingFile: "Selles kaustas olemasolev fail",
    destination: "Sihtkoht:",
    selectedFolderFallback: "— valitud kaust",
    pickProjectToEnable: "Üleslaadimiseks vali projekt",
  },
  multiSelect: {
    selected: "valitud",
    moveTo: "Liiguta...",
    selectDestination: "Vali sihtkoht",
    noSelection: "Dokumente pole valitud",
  },
  versions: {
    latest: "Uusim",
    showAll: "Näita kõiki versioone",
    hideAll: "Peida versioonid",
    compare: "Võrdle",
    versionCount: "versiooni",
  },
  comparison: {
    title: "Dokumendi võrdlus",
    compare: "Võrdle",
    sideBySide: "Kõrvuti vaade",
    tabbed: "Vahekaartide vaade",
    notEnoughVersions: "Võrdluseks on vaja vähemalt kahte versiooni",
    loadError: "Võrdlusdokumentide laadimine ebaõnnestus",
    close: "Sulge",
    analysisTitle: "Erinevuste analüüs",
    analyzing: "Erinevuste analüüsimine...",
    noChanges: "Olulisi muudatusi ei tuvastatud",
    wordDocFallback: "Wordi dokumentide võrdlus pole saadaval",
    selectVersions: "Vali 2 versiooni võrdlemiseks",
  },
  search: {
    title: "Otsing",
    placeholder: "Otsi dokumente...",
    noDocuments: "Ükski dokument ei vasta otsingule",
    scope: {
      currentView: "praeguses vaates",
      folder: 'kaustas "{folder}"',
      allDocuments: "kõikides dokumentides",
    },
    toggleLabel: "Otsi kõiki hoone dokumente",
    sortLabel: "Sorteeri:",
    result: "tulemus",
    results: "tulemust",
    contentPartial:
      "Osa dokumendi tekstis leitud vasteid võib puududa. Nende nägemiseks täpsusta otsingut.",
    contentUnavailable:
      "Dokumendi tekstist otsimine pole praegu saadaval. Tulemused vastavad ainult failinimedele.",
  },
  chat: {
    title: "Dokumentide vestlus",
    placeholder: "Mida sa leida vajad?",
    error: "Päringu töötlemine ebaõnnestus",
    examples: ["Leia kõik arhitektuurifailid", "Näita mulle korruseplaane", "Loenda kõik lepingud"],
    empty:
      'Vestle oma dokumentidega. Küsi näiteks "Leia kõik arhitektuurifailid" või "Näita mulle korruseplaane"',
    noDocuments: "Ükski dokument ei vasta otsingule",
  },
  filters: {
    title: "Filtrid",
    all: "Kõik",
    recent: "Hiljutised",
    search: "Otsingutulemused",
    filterByType: "Filtreeri tüübi järgi",
    clear: "Tühjenda filtrid",
    showing: "Kuvatakse {filtered}/{total} dokumenti",
    active: "Aktiivsed filtrid",
    filtered: "Filtreeritud",
    allTypes: "Kõik tüübid",
  },
  tabs: {
    documents: "Dokumendid",
    chat: "Vestlus",
    upload: "Lae üles",
    analytics: "Analüütika",
  },
  emptyState: {
    title: "Dokumendid puuduvad",
    description: "Alustamiseks lae üles oma esimene dokument",
    uploadButton: "Lae dokument üles",
  },
  uploadOrDrop: "Lae üles või lohista failid",
  uploadComplete: "Üleslaadimine valmis",
  documentCounts: {
    total: "Dokumente kokku",
    pdf: "PDF dokumendid",
    word: "Wordi dokumendid",
    excel: "Exceli dokumendid",
    image: "Pildifailid",
  },
  viewer: {
    download: "Lae alla",
    openInNewTab: "Ava uuel vahelehel",
    zoomIn: "Suurenda",
    zoomOut: "Vähenda",
    fitWidth: "Sobita laiusega",
    page: "Lehekülg",
    loading: "PDF-i laadimine…",
  },
  analytics: {
    storageUsage: "Salvestusruumi kasutus (MB)",
  },
  uploadProgress: {
    analyzing: "Analüüsimine...",
    uploading: "Üleslaadimine...",
    complete: "Valmis",
    failed: "Ebaõnnestunud",
  },
  processingBar: {
    title: "Failide töötlemine",
    message:
      "Franklin lisab teie üleslaetud failidele metaandmete silte, et neid saaks sorteerida ja teie andmed püsiksid korras. See toimub automaatselt — võite tööd jätkata.",
    documentsProcessing: "{count} dokument(i) töötlemisel",
  },
  uploadQueue: {
    receivingFiles: "Võtan sinu faile vastu…",
    receivedFiles: "Kõik sinu failid on kohal.",
    receivedFilesWithFailures: "Sain kätte {completed} faili {total}-st.",
    receivingShort: "Võtan sinu faile vastu…",
    processingMessage: "Kõik {count} faili on kohal. Loen ja sildistan neid nüüd.",
    processingMessageOne: "Sinu fail on kohal. Loen ja sildistan seda nüüd.",
    uploadingFiles: "Failide üleslaadimine",
    uploadComplete: "Üleslaadimine valmis",
    filesProgress: "{completed} / {total} failist",
    done: "valmis",
    uploading: "üleslaadimisel",
    pending: "ootel",
    failed: "ebaõnnestus",
    skipped: "vahele jäetud",
    retryFailed: "Proovi uuesti ({count})",
    processingDocuments: "Töötlen {count} dokumenti",
    extractingText: "Teksti eraldamine…",
    extractingProgress: "Teksti eraldamine · {done} / {total} valmis",
    processingShort: "Loen {count} faili…",
    notifyWhenDone: "Anna mulle teada, kui valmis →",
    notifySubscribed: "Annan sulle teada.",
    minimize: "Minimeeri",
    expand: "Laienda",
    dismiss: "Peida",
    cancelAll: "Tühista kõik",
    close: "Sulge",
  },
  classification: {
    inProgress: "Tehisintellekt klassifitseerib faile",
    complete: "Klassifitseerimine lõppenud",
    failed: "Klassifitseerimine ebaõnnestus",
    processing: "Klassifitseerimine käib",
    preparing: "Klassifitseerimise ettevalmistamine",
    runningMessage:
      "AI klassifitseerib üleslaetud faile. Failid liigutatakse automaatselt sobivatesse kaustadesse.",
    completedMessage: "Klassifitseerimine tehtud! Failid on paigutatud sobivatesse kaustadesse.",
    failedMessage: "Klassifitseerimine ebaõnnestus. Failid jäävad oma praegusesse asukohta.",
    preparingMessage:
      "Üleslaetud failide automaatseks klassifitseerimiseks valmistumine. See võib võtta hetke...",
    uploadNotAvailable: "Üleslaadimine pole saadaval",
    setupRequired: "Seadistus nõutav",
    userProfileError: "Kasutajaprofiili ei leitud. Palun logi sisse.",
    organizationError:
      "Organisatsiooni pole valitud. Palun vali organisatsioon enne failide üleslaadimist.",
    loginPrompt: "Palun logi sisse.",
    organizationPrompt: "Palun vali failide üleslaadimiseks organisatsioon.",
  },
  tags: {
    added: "Silt lisatud",
    removed: "Silt eemaldatud",
    error: "Sildi viga",
    tagAdded: "Silt lisatud",
    tagRemoved: "Silt eemaldatud",
    addError: "Sildi lisamine eba\u00F5nnestus",
    removeError: "Sildi eemaldamine eba\u00F5nnestus",
    searchPlaceholder: "Otsi silte...",
    noOptions: "Sildi valikuid pole saadaval",
    createCustom: "Loo kohandatud silt",
    projects: "Projektid",
    folders: "Kaustad",
    custom: "Kohandatud sildid",
  },
  log: {
    title: "Dokumentide logi",
    subtitle: "Tegevuste logi hoone {buildingName} jaoks",
    backButton: "Tagasi dokumentide juurde",
    searchPlaceholder: "Otsi faile...",
    allTypes: "K\u00F5ik t\u00FC\u00FCbid",
    newFile: "Uus fail",
    updated: "Uuendatud",
    deleted: "Kustutatud",
    restored: "Taastatud",
    moved: "Liigutatud",
    allUsers: "K\u00F5ik kasutajad",
    allTags: "K\u00F5ik sildid",
    fromDate: "Alates kuup\u00E4evast",
    toDate: "Kuni kuup\u00E4evani",
    clearButton: "T\u00FChjenda",
    typeHeader: "T\u00FC\u00FCp",
    fileNameHeader: "Faili nimi",
    dateTimeHeader: "Kuup\u00E4ev ja kellaaeg",
    changedByHeader: "Muutja",
    tagsHeader: "Sildid",
    loadingActivities: "Tegevuste laadimine...",
    noActivitiesMatched: "\u00DCkski tegevus ei vasta teie filtritele",
    noActivities: "Tegevusi ei leitud",
    noTags: "Silte pole",
    history: {
      title: "Dokumendi ajalugu",
      actionLabel: "Dokumendi ajalugu",
      projectSubtitle: "Projekt — {name}",
      buildingSubtitle: "Hoone — {name}",
      timelineLabel: "Dokumentide tegevuste ajajoon",
      searchPlaceholder: "Otsi dokumente, inimesi v\u00F5i failinimesid",
      filterLabel: "Filtreeri dokumenditegevusi",
      filters: {
        all: "K\u00F5ik tegevused",
        added: "Lisatud",
        edited: "Muudetud",
        renamed: "\u00DCmber nimetatud",
        deleted: "Kustutatud",
        restored: "Taastatud",
      },
      actorFilterLabel: "Filtreeri inimese j\u00E4rgi",
      anyone: "K\u00F5ik inimesed",
      filterSections: {
        activity: "Tegevus",
        person: "Isik",
        fileType: "Failitüüp",
        date: "Kuupäev",
      },
      fileTypeFilterLabel: "Filtreeri failit\u00FC\u00FCbi j\u00E4rgi",
      allFileTypes: "K\u00F5ik failit\u00FC\u00FCbid",
      unknownFileType: "Muud failid",
      dateFilter: {
        label: "Filtreeri kuup\u00E4eva j\u00E4rgi",
        anyTime: "Kogu aeg",
        today: "T\u00E4na",
        last7Days: "Viimased 7 p\u00E4eva",
        last30Days: "Viimased 30 p\u00E4eva",
        customRange: "Kohandatud vahemik",
        apply: "Rakenda",
        clear: "T\u00FChjenda kuup\u00E4evafilter",
      },
      verbs: {
        added: "lisas",
        edited: "muutis",
        renamed: "nimetas \u00FCmber",
        deleted: "kustutas",
        restored: "taastas",
      },
      eventTypes: {
        added: "Lisamise s\u00FCndmus",
        edited: "Muutmise s\u00FCndmus",
        renamed: "\u00DCmbernimetamise s\u00FCndmus",
        deleted: "Kustutamise s\u00FCndmus",
        restored: "Taastamise s\u00FCndmus",
      },
      changes: {
        fields: {
          filename: "Failinimi",
          categories: "Kategooriad",
          disciplines: "Distsipliinid",
          stages: "Etapid",
        },
        before: "Enne",
        after: "P\u00E4rast",
        none: "Puudub",
      },
      relativeTime: {
        justNow: "just praegu",
        minutes: "{count} min tagasi",
        hours: "{count} t tagasi",
        days: "{count} p tagasi",
        weeks: "{count} n\u00E4d tagasi",
        months: "{count} k tagasi",
      },
      dayGroups: {
        today: "T\u00E4na",
        yesterday: "Eile",
      },
      version: "Versioon {version}",
      unknownUser: "Tundmatu kasutaja",
      loading: "Dokumentide ajaloo laadimine…",
      emptyProject: "Selles projektis pole veel dokumenditegevusi.",
      emptyBuilding: "Selles hoones pole veel dokumenditegevusi.",
      filteredEmpty: "\u00DCkski tegevus ei vasta filtrile.",
      filteredEmptyLoaded:
        "\u00DCkski laaditud tegevus ei vasta filtrile. Vanemad tegevused v\u00F5ivad vastata: vajuta \u201ELaadi vanemad\u201C, et otsida kaugemalt.",
      clearFilters: "T\u00FChjenda filtrid",
      loadError: "Dokumendi ajalugu ei \u00F5nnestunud laadida.",
      retry: "Proovi uuesti",
      loadOlder: "Laadi vanemad",
      loadingOlder: "Vanemate laadimine…",
      eventCount: "{shown} / {total} s\u00FCndmust",
      open: "Ava",
      download: "Laadi alla",
      versionHistory: "Versiooniajalugu",
      restore: "Taasta",
      close: "Sulge dokumendi ajalugu",
      resizePanel: "Muuda dokumendi ajaloo paneeli suurust",
      downloadErrorTitle: "Allalaadimine eba\u00F5nnestus",
      downloadError: "Dokumenti ei saanud alla laadida.",
      restoreSuccess: "Dokument taastatud",
      restoreErrorTitle: "Taastamine eba\u00F5nnestus",
      restoreError: "Dokumenti ei saanud taastada.",
    },
  },
  manage: {
    subtitle: "Lohistage failid üleslaadimiseks ja hallake dokumente",
    manageShares: "Halda jagamisi",
  },
  trash: {
    title: "Pr\u00FCgikast",
    description: "Kustutatud dokumente hoitakse siin 30 p\u00E4eva enne l\u00F5plikku eemaldamist",
    backButton: "Tagasi dokumentide juurde",
    loadingTrash: "Pr\u00FCgikasti laadimine...",
    emptyTitle: "Pr\u00FCgikast on t\u00FChi",
    emptyDescription:
      "Kui kustutate dokumente, ilmuvad need siia, kus saate neid 30 p\u00E4eva jooksul taastada.",
    purgeWarning: "Dokumendid kustutatakse automaatselt 30 p\u00E4eva m\u00F6\u00F6dumisel",
    restore: "Taasta",
    restoreDocumentTitle: "Taasta dokument?",
    restoreDocumentConfirm: "Kas taastada \u201E{filename}\u201C pr\u00FCgikastist?",
    restoreDocumentConfirmFallback: "Kas taastada see dokument pr\u00FCgikastist?",
    documentCount: "{count} dokumenti",
    nameColumn: "Nimi",
    deletedColumn: "Kustutatud",
    sizeColumn: "Suurus",
    selectAll: "Vali k\u00F5ik",
    selectedCount: "{count} valitud",
    clearSelection: "T\u00FChista valik",
    permanentDelete: "Kustuta j\u00E4\u00E4davalt",
    permanentDeleteTitle: "Kustuta j\u00E4\u00E4davalt?",
    permanentDeleteConfirm:
      "Kas kustutada \u201E{filename}\u201C j\u00E4\u00E4davalt? Seda toimingut ei saa tagasi v\u00F5tta.",
    permanentDeleteConfirmFallback:
      "Kas kustutada see dokument j\u00E4\u00E4davalt? Seda toimingut ei saa tagasi v\u00F5tta.",
    bulkPermanentDeleteTitle: "Kustuta j\u00E4\u00E4davalt?",
    bulkPermanentDeleteConfirm:
      "Kas kustutada {count} dokumenti j\u00E4\u00E4davalt? Seda toimingut ei saa tagasi v\u00F5tta.",
    confirmPermanentDelete: "Kustuta j\u00E4\u00E4davalt",
    emptyTrashButton: "T\u00FChjenda pr\u00FCgikast",
    emptyTrashTitle: "T\u00FChjenda pr\u00FCgikast?",
    emptyTrashConfirm:
      "Kas kustutada j\u00E4\u00E4davalt k\u00F5ik {count} dokumenti pr\u00FCgikastis? Seda toimingut ei saa tagasi v\u00F5tta.",
  },
  bulkActions: {
    selectedCount: "dokumenti valitud",
    signature: "Allkiri",
    share: "Jaga",
    download: "Laadi alla",
    moveCopy: "Liiguta/Kopeeri",
    askFranklin: "K\u00FCsi Franklinilt",
    comparePdfs: "V\u00F5rdle PDF-e",
    diffOverview: "V\u00F5rdle IFCsid",
    viewDrawing: "Vaata joonist",
    compareDrawings: "V\u00F5rdle jooniseid",
    moveToTrash: "Kustuta",
    confirmTrashTitle: "Liiguta prügikasti?",
    confirmTrashDescription: "Kas olete kindel, et soovite {count} dokumenti prügikasti liigutada?",
    clear: "Tühjenda",
    rename: "Nimeta ümber",
    addNewVersion: "Lisa uus versioon",
    versioning: "Versioonid",
    more: "Veel",
    verify: "Märgi kinnitatuks",
    unverify: "Eemalda kinnitus",
    comments: "Kommentaarid",
  },
  comments: {
    title: "Kommentaarid",
    openCount: "Avatud: {count}",
    resolvedCount: "Lõpetatud: {count}",
    placeholder: "Kirjuta kommentaar – kasuta @, et kedagi mainida",
    replyPlaceholder: "Kirjuta vastus",
    commentOnPage: "Kommenteerid lehekülge {page}",
    commentOnDocument: "Kommenteerid dokumenti",
    pageAnchorToggle: "Lehekülg {page}",
    sheetAnchorToggle: "Tööleht: {name}",
    commentOnSheet: "Kommenteerid töölehte {name}",
    sheet: "Tööleht {page}",
    goToSheet: "Ava tööleht {page}",
    markComplete: "Märgi lõpetatuks",
    reopen: "Ava uuesti",
    completedBy: "Lõpetas {name}",
    completed: "Lõpetatud",
    reply: "Vasta",
    edit: "Muuda",
    edited: "muudetud",
    save: "Salvesta",
    cancel: "Loobu",
    send: "Saada",
    mention: "Maini kedagi",
    attach: "Lisa manus",
    removeQuote: "Eemalda tsitaat",
    delete: "Kustuta",
    confirmDelete: "Kustuta see vastus?",
    confirmDeleteDescription: "Vastus eemaldatakse lõimest.",
    deleteThread: "Kustuta lõim",
    confirmDeleteThread: "Kustuta see lõim?",
    confirmDeleteThreadDescription: "Kommentaar ja kõik selle vastused eemaldatakse.",
    createIssue: "Loo ülesanne",
    createIssueOption: "Loo ülesanne",
    createIssueOptionHint:
      "Salvestab kommentaari dokumendi ülesande alamülesandena. Eemalda linnuke, et jätta see vaid kommentaariks.",
    noProjectForIssue: "See dokument ei kuulu projekti, seega ei saa seda ülesandena esitada.",
    issueBacked: "Ülesanne #{number} — vastused siin on ülesande kommentaarid",
    linkedIssue: "Ülesanne #{number}",
    moreActions: "Rohkem toiminguid",
    historyAction: "Ajalugu",
    historyTitle: "Lõime ajalugu",
    historyEmpty: "Sündmusi pole veel.",
    systemActor: "Süsteem",
    history: {
      thread_created: "{name} alustas lõime",
      comment_added: "{name} vastas",
      comment_edited: "{name} muutis kommentaari",
      comment_deleted: "{name} kustutas vastuse",
      resolved: "{name} märkis lõpetatuks",
      reopened: "{name} avas uuesti",
      issue_created: "{name} lõi ülesande",
      thread_deleted: "{name} kustutas lõime",
    },
    page: "lk {page}",
    version: "v{version}",
    viewingVersion: "Vaatad",
    goToPage: "Mine leheküljele {page}",
    openDocument: "Ava dokument",
    emptyOpen: "Avatud kommentaare pole.",
    emptyResolved: "Lõpetatud kommentaare pole.",
    unavailable: "Kommentaarid pole veel saadaval.",
    loadError: "Kommentaare ei õnnestunud laadida.",
    writeFailed: "Kommentaari ei õnnestunud salvestada.",
    threadUnavailable: "See kommentaarilõim pole saadaval.",
    issueLinkFailed: "Ülesanne loodi, kuid seda ei õnnestunud lõimega siduda.",
    retry: "Proovi uuesti",
    rowBadge: "Avatud kommentaare: {count}",
    unknownUser: "Tundmatu kasutaja",
    justNow: "just nüüd",
    yesterday: "eile",
    toggleRail: "Kommentaarid",
    origin: "Loodud dokumendi {filename} kommentaarist",
    originPage: "Loodud dokumendi {filename} kommentaarist (lk {page})",
  },
  verified: {
    label: "Kinnitatud",
    tooltip: "Kinnitas {name} {date}",
    tooltipUnknownUser: "Kinnitatud {date}",
    verifiedToast: "{count} dokument(i) märgiti kinnitatuks",
    unverifiedToast: "{count} dokumendilt eemaldati kinnitus",
    verifiedToastWithAlready:
      "{count} dokument(i) märgiti kinnitatuks — {already} oli(d) juba kinnitatud",
    unverifiedToastWithAlready:
      "{count} dokumendilt eemaldati kinnitus — {already} ei olnud kinnitatud",
    confirmVerifyDescription:
      "Salvestab sind selle versiooni kontrollijana. Uue versiooni lisamisel on dokument taas kinnitamata.",
    confirmUnverifyDescription:
      "Eemaldab kinnituse ja teabe selle kohta, kes dokumenti kontrollis.",
    undo: "Võta tagasi",
    error: "Kinnituse muutmine ebaõnnestus. Palun proovi uuesti.",
    partialError: "Uuendada õnnestus ainult {count} dokumenti {total}-st.",
    partialErrorWithUnknown:
      "Uuendada õnnestus ainult {count} dokumenti {total}-st. {unknown} dokumendi olekut ei õnnestunud kontrollida — palun proovi uuesti.",
    alreadyVerified: "Juba kinnitatud — midagi uuendada ei ole.",
    alreadyUnverified: "Ei ole kinnitatud — midagi uuendada ei ole.",
  },
  empty: {
    dropHere: "Lohistage failid siia",
    uploadFirst: "Laadige \u00FCles oma esimesed dokumendid",
    description:
      "Alustage dokumentide \u00FCleslaadimisega, et korraldada oma hoone teavet. Saate faile siia lohistada v\u00F5i klikkida alloleval nupul.",
    uploadButton: "Lae dokumendid \u00FCles",
    fileTypes: "Toetab PDF, DOC, DOCX, pilte ja muud",
    autoCategorisation: "Failide automaatne kategoriseerimine ja m\u00E4rgistamine",
    autoCategorisationDesc:
      "Teie \u00FCleslaaditud dokumendid kategoriseeritakse ja m\u00E4rgistatakse automaatselt nende sisu p\u00F5hjal, muutes hoone teabe leidmise ja korraldamise lihtsaks.",
    timelineVersioning: "Dokumentide ajajoon ja versioonihaldus",
    timelineVersioningDesc:
      "J\u00E4lgige dokumentide muudatusi ajas visuaalse ajajoonega. V\u00F5rrelge versioone ja vaadake, kuidas teie hoone dokumentatsioon on arenenud.",
    filteredTitle: "Praegustele filtritele ei vasta ükski dokument",
    filteredDescription: "Muutke või tühjendage filtreid ja otsingut, et näha rohkem dokumente.",
    clearFilters: "Tühjenda filtrid",
  },
  folders: {
    issueAttachments: "Ülesande lisad",
    pinned: {
      cannotRemove: "Faili „{filename}“ ei saa kaustast „{folder}“ eemaldada.",
      issueAttachmentHint: "Kopeeri see hoopis või eemalda see ülesandelt.",
      copyInsteadHint: "Kopeeri see hoopis.",
      moreCannotRemove: "Teisi faile, mida ei saa kaustast eemaldada: {count}",
    },
    createDialog: {
      title: "Loo uus kaust",
      subfolder: 'Loo alamkaust kausta "{name}" sisse',
      description:
        "Looge uus kohandatud kaust oma dokumentide korraldamiseks. Hiljem saate parema organiseerimise jaoks lisada alamkaustu.",
      subfolderDesc:
        'Looge uus kaust kausta "{name}" sisse. Alamkaustad aitavad korraldada seotud dokumente \u00FChes peakategoorias.',
      nameLabel: "Kausta nimi",
      namePlaceholder: "Sisestage kausta nimi...",
      parentLabel: "\u00DClemkaust (valikuline)",
      parentPlaceholder: "Valige \u00FClemkaust...",
      noParent: "Ilma \u00FClemkaustata (juurtase)",
      nameLengthError: "Kausta nimi peab olema 1 kuni 100 t\u00E4hem\u00E4rki",
      invalidChars: 'Kausta nimi ei tohi sisaldada: < > : " / \\ | ? *',
    },
    unreachableTruncated:
      "Projekti juurkaustas kuvatakse {count} valesti paigutatud dokumenti {total}-st. Liiguta need kausta, et n\u00E4ha \u00FClej\u00E4\u00E4nuid.",
  },
  actions2: {
    openMenu: "Ava tegevuste men\u00FC\u00FC",
    moveCopyAction: "Liiguta/Kopeeri...",
    rename: "Nimeta \u00FCmber",
  },
  rename: {
    success: "Dokument nimetatud \u00FCmber",
    successDescription: "Uus nimi: {name}",
    errorTitle: "\u00DCmbernimetamine eba\u00F5nnestus",
    errorEmpty: "Nimi ei tohi olla t\u00FChi",
    errorTooLong: "Nimi on liiga pikk (kuni {max} t\u00E4hem\u00E4rki)",
    errorInvalidChars: 'Nimi ei tohi sisaldada: < > : " / \\ | ?',
    errorExtensionChanged: "Faililaiendit ei saa muuta (peab j\u00E4\u00E4ma {ext})",
    errorCollision: 'Dokument nimega "{name}" on selles kaustas juba olemas',
    errorNotFound: "Dokumenti enam ei eksisteeri",
    errorUnknown: "Dokumendi \u00FCmbernimetamine eba\u00F5nnestus",
  },
  dragDrop: {
    prompt: "Lohistage failid v\u00F5i kaustad siia \u00FCleslaadimiseks",
    orClick: "v\u00F5i kl\u00F5psake sirvimiseks",
  },
  uploadErrors: {
    fileTooLarge: "See fail ületab maksimaalse üleslaadimise suuruse (maksimaalne 50 MB)",
    unsupportedFileType: "Seda failitüüpi ei toetata!",
    authError: "Üleslaadimiseks on vajalik autentimine",
    networkError: "Võrguviga üleslaadimise ajal",
    uploadFailed: "Üleslaadimine ebaõnnestus",
    serverError: "Serveri viga üleslaadimise ajal",
    documentRecordFailed: "Dokumendikirje loomine ebaõnnestus",
  },
  uploadProgressTitle: "Faili \u00FCleslaadimise edenemine",
  uploadFailedMessage:
    "\u00DClesladiimine eba\u00F5nnestus. Palun kontrollige konsooli lisateabe saamiseks.",
  categorySelector: {
    allDocumentsTitle: "K\u00F5ik dokumendid ja kaustad",
    allDocumentsDescription: "Sirvige k\u00F5iki oma dokumente ja kaustu \u00FChes kohas",
    startingClassification: "Klassifitseerimise alustamine...",
    aiFileClassification: "AI failide klassifitseerimine",
    advancedOptions: "T\u00E4psemad klassifitseerimise valikud",
    buildingIdLabel: "Hoone ID",
    buildingIdHint: "Hoone ID klassifitseerimiseks (kasutage 0 k\u00F5igi hoonete jaoks).",
    modeLabel: "Re\u017Eiim",
    modeNew: "Uus",
    modeAll: "K\u00F5ik",
    modeHint: "Klassifitseeri ainult uued failid v\u00F5i klassifitseeri k\u00F5ik failid uuesti.",
    scopeLabel: "Ulatus (p\u00E4evades)",
    scopeHint: "K\u00E4ivita ainult failidel, mis on uuemad kui see arv p\u00E4evi.",
    searchLabel: "Otsing",
    fileTypes: {
      pdf: "PDF dokumendid",
      images: "Pildid",
      documents: "Tekstidokumendid",
      spreadsheets: "Tabelid",
      presentations: "Esitlused",
      archives: "Arhiivid",
    },
  },
  table: {
    name: "Nimi",
    search: "Otsi",
    searchByName: "Otsi dokumente...",
    searchInFolder: "Otsi kaustast...",
    searching: "Otsin",
    pressEnterToSearch: "Otsimiseks vajuta Enter",
    clearSearch: "Tühjenda otsing",
    loadingDocuments: "Dokumentide laadimine...",
    loadError: "Viga dokumentide laadimisel",
    noDocumentsFound: "Dokumente ei leitud",
    noSearchResultsHint: "Proovi teist otsingusõna",
    noDocumentsHint: "Alustamiseks laadi üles dokument",
    dateCreated: "Loomise kuupäev",
    dateModified: "Faili muutmisaeg",
    fileModifiedColumnTooltip:
      "Faili enda metaandmetesse salvestatud loomise või muutmise kuupäev, mis võib olla üleslaadimisest varasem. Kui failis kuupäeva pole, näidatakse üleslaadimise kuupäeva.",
    fileModifiedTooltip: "Viimati muudetud {date} (faili metaandmete järgi).",
    fileCreatedTooltip: "Loodud {date} (faili metaandmete järgi). Failis pole muutmise kuupäeva.",
    fileDateMissingTooltip:
      "Faili metaandmetes pole kuupäeva, seega on see Franklinisse üleslaadimise aeg ({date}).",
    uploadedTooltip:
      "Üleslaadimise aeg: millal fail Franklinisse lisati. See ei ole failis endas talletatud kuupäev — vaata faili muutmisaega.",
    version: "Versioon",
    status: "Olek",
    user: "Kasutaja",
    dateUploaded: "Lisatud",
    dateModifiedShort: "Muudetud",
    dateColumnSwitchLabel: "Näita kuupäeva",
    dateColumnUploadedOption: "Üleslaadimise kuupäev",
    dateColumnModifiedOption: "Faili muutmise kuupäev",
    dateColumnUploadedHint: "Millal fail Franklinisse lisati",
    dateColumnModifiedHint: "Faili enda metaandmetest, võib olla üleslaadimisest varasem",
    sortByDate: "Sorteeri kuupäeva järgi",
    uploadedAtTooltip: "Franklinisse üles laaditud {date}.",
    uploader: "Lisaja",
    uploaderUnknown: "Lisaja teadmata",
    uploadedByTooltip: "Lisaja: {name}.",
    tags: "Sildid",
    parent: "Ülemkaust",
    actions: "Tegevused",
    selectAll: "Vali kõik dokumendid",
    contentMatch: "Sisu",
    createdByFranklin: "Koostas Franklin",
    contentMatchTooltip: "Leitud dokumendi tekstist",
    contentMatchOnPage: "Leitud lehel {page}",
    contentMatchOnSheet: "Leitud lehel {sheet}",
    contentMatchMore: " (+{count} veel)",
    paginationOf: "/",
    previousPage: "Eelmine leht",
    nextPage: "Järgmine leht",
  },
  addedFilter: {
    title: "Lisatud",
    hint: "Filtreerib üleslaadimise kuupäeva järgi — millal dokumendid Franklinisse lisati.",
    anyTime: "Kõik",
    last7Days: "Viimased 7 päeva",
    last30Days: "Viimased 30 päeva",
    apply: "Rakenda",
    clear: "Eemalda lisamise kuupäev",
  },
  teachFranklin: {
    modalTitle: "Dokumendi sildid",
    modalDescription: "Aidake AI klassifitseerimist parandada, korrigeerides silte faili jaoks",
    successTitle: "Dokumendi sildid",
    successDescription: "Dokumendi sildid on edukalt uuendatud.",
    errorTitle: "Viga",
    errorDescription: "Dokumendi siltide uuendamine ebaõnnestus. Palun proovige uuesti.",
    cancel: "Tühista",
    saveChanges: "Salvesta muudatused",
    saving: "Salvestamine...",
    tagsSelected: "{count} silt(i) valitud",
  },
  tagFilter: {
    searchTags: "Otsi silte…",
    projects: "Projektid",
    categories: "Kategooriad",
    designDisciplines: "Valdkonnad",
    designStages: "Projekti staadiumid",
    clearAll: "Tühjenda kõik",
    noMatches: "Päringule „{query}” vasteid ei leitud",
    loadFailed: "Filtreeritud dokumentide laadimine ebaõnnestus. Kuvatakse ainult see kaust.",
    valuesLoadFailed: "Filtrite valikute laadimine ebaõnnestus.",
    truncated:
      "Liiga palju vasteid — kuvatakse ainult uusimad. Kitsenda filtrit, et näha ülejäänuid.",
    verifiedOnly: "Ainult kinnitatud",
  },
  viewToggle: {
    folders: "Kaustad",
    list: "Nimekiri",
    timeline: "Ajajoon",
    listView: "Nimekirja vaade",
    timelineView: "Ajajoonvaade",
  },
  chatSidebar: {
    title: "Franklin",
    subtitle: "Vestle oma dokumentidega",
    selectChat: "Vali vestlus...",
    chatHistory: "Vestluste ajalugu",
    greetings: {
      personalised: [
        "Tere {firstName}! Olen Franklin.",
        "Tere, {firstName} — Franklin siin.",
        "Tere tulemast tagasi, {firstName}. Franklin siin.",
        "Tere, {firstName}. Franklin siin, olen valmis.",
        "Rõõm sind näha, {firstName}. Olen Franklin.",
      ],
      anonymous: [
        "Tere! Olen Franklin.",
        "Tere — Franklin siin.",
        "Tere tulemast tagasi. Franklin siin.",
        "Tere. Franklin siin, olen valmis.",
        "Rõõm sind näha. Olen Franklin.",
      ],
    },
    tips: [
      "Küsi minult midagi oma hoone kohta.",
      "NIPP: Lohista fail otse siia aknasse ja loen selle enne küsimist läbi.",
      "Kas teadsid? Nupp + suunab mind ühte projekti — siis vaatan ainult sealt.",
      "NIPP: Oskan koostada PDF-, Wordi- või Exceli faili kõigest, mida leian.",
      "Kas teadsid? Lülita gloobus sisse ja otsin lisaks dokumentidele ka veebist.",
      "NIPP: Oskan võrrelda dokumendi kahte versiooni või IFC-faili kahte redaktsiooni.",
      "Kas teadsid? Franklin avab iga IFC-faili 3D vaates koos korruste kaupa lõigetega.",
      "NIPP: Lisa dokumendile uus versioon — laadi fail üles või vali olemasolev — ja kogu ajalugu säilib.",
      "Kas teadsid? Kahte DWG-joonist saab jooniste vaates võrrelda, et näha täpselt, mis muutus.",
      "NIPP: Lülita dokumendid ajajoone vaatesse, et näha, millal need saabusid, mitte kuhu need salvestati.",
      "Kas teadsid? Dokumente saab Franklinis allkirjastada ja allkirjastatud ümbrik salvestub kohe tagasi.",
      "NIPP: Jaga dokumenti Franklini-välise inimesega aeguva lingiga.",
    ],
    scopeFallback: "see hoone",
    examples: {
      docsRecent: "Mis on sel nädalal {scope} lisatud {count} dokumendis?",
      docsRecentOne: "Mis on sel nädalal {scope} lisatud dokumendis?",
      docsLatest:
        "Tee kokkuvõte {scope} viimasest üleslaadimisest — mis see on ja mida peaksin teadma?",
      docsBrief: "Anna {scope} kohta lühiülevaade selle dokumentide põhjal.",
      docsVerified: "Millised {scope} dokumendid on kasutaja kinnitanud?",
      docsEmpty: "Millised dokumendid tuleks {scope} jaoks lisada?",
      docsUnavailable: "Mida peaksin teadma {scope} dokumentide kohta?",
      issuesOverdue: "Milline {scope} {count} tähtaja ületanud ülesandest vajab kohe tähelepanu?",
      issuesOverdueOne: "Üks {scope} ülesanne on tähtaja ületanud — mida see vajab?",
      issuesOpen: "Millisega {scope} {count} avatud ülesandest peaksin alustama?",
      issuesOpenOne: "{scope} on üks avatud ülesanne — mida see vajab?",
      issuesNew: "Tee kokkuvõte {scope} sel nädalal avatud {count} ülesandest.",
      issuesNewOne: "Tee kokkuvõte {scope} sel nädalal avatud ülesandest.",
      issuesMine: "Mis mul teha on — räägi mulle minu {count} avatud ülesandest.",
      issuesMineOne: "Räägi mulle mulle määratud avatud ülesandest.",
      issuesSuggest: "Loe uusimad dokumendid läbi ja paku välja ülesanded, mida tasuks avada.",
      issuesEmpty: "Kas {scope} on lahendamata ülesandeid?",
      modelDiff: "Mis muutus {filename} kahe viimase redaktsiooni vahel?",
      modelDiffQuantities: "Võrdle uusimat IFC-faili eelmisega — millised kogused muutusid?",
      modelOverview: "Tee kokkuvõte {scope} IFC-failist — korrused, pinnad ja peamised materjalid.",
      modelTakeoff: "Milline on {scope} IFC-faili materjalide kogus?",
      dataMissing: "Millised hoone andmeväljad on {scope} jaoks veel täitmata?",
      dataChanges: "Millised hoone andmed on hiljuti muutunud ja kes neid muutis?",
      outputPdf: "Koosta {scope} kohta PDF-kokkuvõte, mille saan kliendile saata.",
      outputExcel: "Ekspordi {scope} avatud ülesanded Exceli faili.",
      outputDocx: "Koosta Wordi dokument, mis loetleb, mis on {scope} kohta seni esitatud.",
      guideCapabilities: "Millega sa mind siin aidata saad?",
      guideUpload: "Kuidas Franklinis dokumente üles laadida ja korrastada?",
    },
    nudges: {
      processingDone: "{count} dokumenti on töödeldud ja sildistatud.",
      processingDoneOne: "1 dokument on töödeldud ja sildistatud.",
      newIssues: "Eilsest on avatud {count} uut ülesannet. Kas teen kokkuvõtte?",
      newIssuesOne: "Eilsest on avatud 1 uus ülesanne. Kas teen kokkuvõtte?",
      summarise: "Tee kokkuvõte",
      viewIssues: "Vaata ülesandeid",
      dismiss: "Peida",
      summariseDocumentsPrompt:
        "Tee kokkuvõte {count} äsja töödeldud ja sildistatud dokumendist — mis need on ja mida peaksin nende kohta teadma?",
      summariseIssuesPrompt:
        "Tee kokkuvõte viimase 24 tunni jooksul avatud {count} ülesandest — millest need räägivad ja millega tuleks esimesena tegeleda?",
    },
    drop: {
      attachFiles: "Lohista siia, et üles laadida ja manustada",
      attachDocuments: "Lohista siia, et vestlusele manustada",
      foldersNotAttached:
        "Kaustu ei saa manustada — lohista selle asemel kaustas olevad dokumendid.",
      someDocumentsNotAttached: "Mõnda dokumenti ei õnnestunud manustada.",
      attachFailed: "Dokumentide manustamine ebaõnnestus. Palun proovi uuesti.",
      readFilesFailed: "Lohistatud faile ei õnnestunud lugeda. Palun proovi uuesti.",
    },
    askPlaceholder: "Küsi Franklinilt...",
    launcherIdle: "Küsi Franklinilt…",
    launcherThinking: "Franklin mõtleb",
    openLatestReply: "Ava uusim vastus",
    unreadReply: "1 lugemata vastus",
    loadingChats: "Vestluste laadimine...",
    noChatsYet: "Vestlusi pole veel",
    newChat: "Uus vestlus",
    thinking: "Mõtlen...",
    // Write-tool confirmation card. One turn can raise several, so the card
    // says which of them the user is looking at.
    confirmApprove: "Kinnita",
    confirmDeny: "Keeldu",
    confirmAlwaysAllow: "Luba see tegevus alati",
    confirmAllowForReply: "Luba selle vastuse lõpuni",
    confirmAllowForReplyHint:
      "Franklin ei küsi selle tegevuse kohta enam luba, kuni see vastus on valmis. Järgmisel korral küsib uuesti.",
    confirmSaved: "Salvestatud",
    confirmDeclined: "Keeldutud",
    confirmCounter: "{count} taotlust ootel",
    confirmSubmitFailed: "Otsuse saatmine ebaõnnestus.",
    confirmExpired: "Franklin ei oota enam seda kinnitust.",
    confirmRetry: "Proovi uuesti",
    confirmDismiss: "Sulge",
    statusWorkingOnIt: "Tegelen sellega...",
    statusLookingIntoThat: "Uurin seda...",
    statusProcessing: "Töötlen sinu päringut...",
    statusJustAMoment: "Üks hetk...",
    addFile: "Lisa fail",
    deleteChatTitle: "Kustuta vestlus?",
    deleteChatDescription: "Kas olete kindel, et soovite selle vestluse kustutada?",
    deleteChatConfirm: "Kustuta",
    messages: "sõnumit",
    expandChat: "Laienda vestlust",
    collapseToSidebar: "Ahenda külgribale",
    closeChat: "Sulge vestlus",
    minimizeChat: "Minimeeri vestlus",
    editChatName: "Muuda vestluse nime",
    archiveChat: "Arhiveeri vestlus",
    sendMessage: "Saada sõnum",
    sendingMessage: "Sõnumi saatmine",
    stopGenerating: "Peata genereerimine",
    queuedMessage: "Ootel",
    cancelQueuedMessage: "Tühista ootel sõnum",
    slowProcessingNote: {
      ifc: "IFC-faili töötlemine võib võtta mõne minuti.",
      dwg: "DWG-faili töötlemine võib võtta mõne minuti.",
      both: "IFC- ja DWG-failide töötlemine võib võtta mõne minuti.",
      dismiss: "Sulge",
    },
    composerLimit: {
      counter: "{count} / {limit}",
      counterLabel: "Tähemärke kasutatud: {count} / {limit}",
      overLimit: "Sõnum on saatmiseks liiga pikk. Lühendage see kuni {limit} tähemärgini.",
    },
    sendFailed: {
      tooLong: "Sõnum on pikem kui {limit} tähemärki, seega seda ei saadetud.",
      startFailed:
        "Uut vestlust ei õnnestunud alustada, seega sõnumit ei saadetud. See on alles allolevas väljas — proovige uuesti.",
      notSent: "Sõnumit ei õnnestunud saata. See on alles allolevas väljas — proovige uuesti.",
      uploadFailed:
        "Faili üleslaadimine ebaõnnestus, seega sõnumit ei saadetud. See on tagasi allolevas väljas koos üles laaditud failidega.",
      dismiss: "Sulge",
    },
    editFailed: {
      title: "Sõnumi muutmine ebaõnnestus",
      description: "Eelmist sõnumivahetust ei õnnestunud eemaldada. Proovige uuesti.",
    },
    disclaimerText: "Franklin on tehisintellekt ja võib teha vigu. Palun kontrollige vastused üle.",
    webSearch: {
      toggle: "Lülita veebiotsing",
      enabled: "Veebiotsing lubatud",
      disabled: "Veebiotsing keelatud",
    },
    attachMenu: {
      upload: "Laadi üles",
      addFromFranklin: "Lisa Franklini logist",
      openFiles: "Ava vestluse failid",
      workInProject: "Tööta projektis",
    },
    projectScope: {
      active: "Töötad projektis: {name}",
      remove: "Lõpeta selles projektis töötamine",
      pickerTitle: "Tööta projektis",
    },
  },
  shareDialog: {
    title: "Loo jagamislink",
    description: "Loo ajutine link, et jagada {description} kõigiga.",
    titleLabel: "Pealkiri (valikuline)",
    titlePlaceholder: "nt Projekti joonised ülevaatamiseks",
    expiryLabel: "Link aegub",
    createButton: "Loo link",
    creating: "Loomine...",
    linkCreated: "Jagamislink loodud!",
    linkCreatedToast: "Jagamislink loodud",
    linkReadyToast: "Teie jagamislink on kopeerimiseks valmis.",
    linkCopied: "Link kopeeritud",
    linkCopiedToast: "Jagamislink kopeeritud lõikelauale.",
    failedCreate: "Jagamislingi loomine ebaõnnestus",
    failedCopy: "Kopeerimine ebaõnnestus",
    copyManually: "Palun kopeerige link käsitsi.",
    copyLink: "Kopeeri link",
    copied: "Kopeeritud!",
    expiryNote:
      "See link aegub {expiry} pärast. Kõik, kellel on link, saavad jagatud dokumente vaadata ja alla laadida.",
    document: "dokument",
    documents: "dokumenti",
    folder: "kaust",
    folders: "kausta",
    and: "ja",
    expiryOptions: {
      oneHour: "1 tund",
      twentyFourHours: "24 tundi",
      sevenDays: "7 päeva",
      thirtyDays: "30 päeva",
    },
  },
  manageSharesDialog: {
    title: "Halda jagamislinke",
    description: "Vaadake ja hallake selle hoone dokumentide jagamislinke.",
    failedLoad: "Jagamiste laadimine ebaõnnestus",
    emptyTitle: "Ühtegi jagamislinki pole veel loodud",
    emptyHint: "Lingi loomiseks valige dokumendid ja vajutage Jaga",
    activeHeading: "Aktiivsed ({count})",
    inactiveHeading: "Mitteaktiivsed ({count})",
    statusActive: "Aktiivne",
    statusExpired: "Aegunud",
    statusRevoked: "Tühistatud",
    untitledShare: "Pealkirjata jagamine",
    docSingular: "{count} dokument",
    docPlural: "{count} dokumenti",
    viewSingular: "{count} vaatamine",
    viewPlural: "{count} vaatamist",
    createdAgo: "Loodud {time}",
    copyLinkTitle: "Kopeeri link",
    revokeShareTitle: "Tühista jagamine",
    linkCopiedToastTitle: "Link kopeeritud",
    linkCopiedToastDesc: "Jagamislink kopeeritud lõikelauale.",
    copyFailedToastTitle: "Kopeerimine ebaõnnestus",
    copyFailedToastDesc: "Palun kopeerige link käsitsi.",
    revokedToastTitle: "Jagamine tühistatud",
    revokedToastDesc: "Jagamislink ei ole enam ligipääsetav.",
    revokeFailedToastTitle: "Jagamise tühistamine ebaõnnestus",
    revokeFailedToastDesc: "Palun proovige uuesti",
    revokeConfirmTitle: "Kas tühistada jagamislink?",
    revokeConfirmDesc:
      "See keelab jagamislingi kohe. Kõik, kellel on link, ei pääse enam jagatud dokumentidele ligi.",
    revokeButton: "Tühista jagamine",
    revoking: "Tühistamine...",
    expiry: {
      dayLeft: "{count} päev jäänud",
      daysLeft: "{count} päeva jäänud",
      hourLeft: "{count} tund jäänud",
      hoursLeft: "{count} tundi jäänud",
      minuteLeft: "{count} minut jäänud",
      minutesLeft: "{count} minutit jäänud",
    },
  },
  picker: {
    title: "Vali dokumendid",
    submit: "Lisa",
    project: "Projekt",
    selectProject: "Vali projekt…",
    defaultProject: "(vaikimisi)",
    files: "Failid",
    projectFallback: "Projekt",
    loadingFolders: "Laadin kaustu",
    foldersFailed: "Kaustade laadimine ebaõnnestus.",
    noFolders: "Kaustu veel pole",
    nothingSelected: "Midagi pole valitud",
    selectedOne: "1 dokument valitud",
    selectedMany: "{count} dokumenti valitud",
    projectsFailed: "Projektide laadimine ebaõnnestus. Sulge aken ja proovi uuesti.",
    selectProjectPrompt: "Dokumentide sirvimiseks vali projekt",
    filterPlaceholder: "Filtreeri faile…",
    subfolderSearchFailed: "Alamkaustadest ei õnnestunud otsida — näitan ainult seda kausta.",
    folderDocumentsFailed: "Selle kausta dokumentide laadimine ebaõnnestus.",
    searchTruncated: "Näitan esimest {limit} vastet — otsingu kitsendamiseks jätka kirjutamist.",
    retry: "Proovi uuesti",
    loadingDocuments: "Laadin dokumente",
    showEarlierVersions: "Näita varasemaid versioone",
    hideEarlierVersions: "Peida varasemad versioonid",
    loadingEarlierVersions: "Laadin varasemaid versioone…",
    noEarlierVersions: "Varasemaid versioone pole saadaval",
    attached: "Lisatud",
    documentsFailed: "Dokumentide laadimine ebaõnnestus.",
    tryAgain: "Proovi uuesti",
    emptyFolder: "Selles kaustas pole dokumente",
  },
  versioning: {
    collisionDialog: {
      titleSingle: "1 fail on juba selles kaustas olemas",
      titleMany: "{count} faili on juba selles kaustas olemas",
      subtitle:
        "Vali, kuidas igaühega toimida. Saad laadida üles uue versioonina, hoida mõlemat eraldi failina või jätta vahele.",
      selectAllAria: "Vali kõik kokkulangevused",
      selectRowAria: "Vali {filename}",
      bulk: {
        selectAll: "Vali kõik {count}",
        nSelected: "{count} valitud",
        applyTo: "Rakenda {target} peale:",
        applyToAll: "kõigi",
      },
      row: {
        existingMeta: "Olemasolev: v{version}",
        uploaderLine: "{relTime} · {uploader}",
        uploaderLineNoName: "{relTime}",
        sizeDiff: "{oldSize} → {newSize}",
        sizeSingle: "{size}",
      },
      actions: {
        version: {
          label: "Uus versioon",
          short: "Uus versioon",
          tooltip:
            "Lae üles olemasoleva faili järgmise versioonina (v2, v3, …). Eelmine versioon säilib versiooniajaloos.",
        },
        duplicate: {
          label: "Hoia mõlemat",
          short: "Duplikaat",
          tooltip:
            "Lae üles uue dokumendina. Failinime lõppu lisatakse (1), (2), … sufiks. Mõlemad failid jäävad versiooniks v1.",
        },
        skip: {
          label: "Jäta vahele",
          short: "Jäta vahele",
          tooltip: "Ära seda faili lae üles. Olemasolev fail jääb puutumata.",
        },
      },
      tally: {
        newVersion: "uus versioon",
        duplicate: "duplikaat",
        skipped: "vahele jäetud",
      },
      confirmSingle: "Lae üles 1 fail",
      confirmMany: "Lae üles {count} faili",
      confirmNone: "Üleslaadimiseks pole midagi",
    },
    manage: {
      menuItem: "Versioonid",
      dialogTitle: "Versioonid",
      dialogDescription:
        '"{filename}" — uusim versioon üleval. Järjekorra muutmiseks lohista; ülemine on kehtiv versioon.',
      preview: "Vaata seda versiooni",
      addVersions: "Lisa versioone",
      backToVersions: "Tagasi versioonide juurde",
      current: "Kehtiv",
      becomesCurrent: "Saab kehtivaks versiooniks",
      dragHandle: "Lohista järjekorra muutmiseks",
      moveUp: "Liiguta üles",
      moveDown: "Liiguta alla",
      makeSeparate: "Tee eraldi failiks",
      makeSeparateTooltip: "Eemalda see versioon ajaloost. Sellest saab samas kaustas eraldi fail.",
      keepAsVersion: "Jäta versiooniks",
      separateBadge: "Saab eraldi failiks",
      lastRemainingHint: "Ajalukku peab jääma vähemalt üks versioon.",
      separateNotPermitted:
        "Mõni prügikastis olev versioon asub seal, kus sa faile muuta ei saa, seega ühtegi versiooni ei saa eraldi failiks teha.",
      editNotPermitted: "Saad neid versioone vaadata, kuid sul pole õigust neid muuta.",
      loading: "Versioonide laadimine…",
      loadError: "Versioone ei õnnestunud laadida.",
      retry: "Proovi uuesti",
      save: "Salvesta muudatused",
      saving: "Salvestamine…",
      noChanges: "Muudatusi pole",
      editUnavailable:
        "Versioonide ümberjärjestamine ja eraldamine pole veel saadaval. Versioone saad endiselt lisada.",
      toastSavedTitle: "Versioonid uuendatud",
      toastReorderedDescription: 'Faili "{filename}" uus järjekord on salvestatud.',
      toastDetachedDescription: "Eraldi failideks tehtud versioone: {count}",
      toastRenamedTitle: "Eraldi fail nimetati ümber",
      toastRenamedDescription:
        '"{from}" nimetati ümber nimeks "{to}", sest see nimi on kaustas juba olemas.',
      toastPartialTitle: "Kõiki muudatusi ei salvestatud",
      discardTitle: "Kas loobud muudatustest?",
      discardDescription: "Uut järjekorda ja eraldi failiks märgitud versioone ei salvestata.",
      discardWithStagedDescription:
        "Siinsed salvestamata muudatused ja uute versioonidena lisamiseks valitud failid lähevad kaotsi.",
      discardStagedDescription: "Uute versioonidena lisamiseks valitud failid lähevad kaotsi.",
      keepEditing: "Jätka muutmist",
      discard: "Loobu",
      errors: {
        unavailable: "Versioonide ümberjärjestamine ja eraldamine pole veel saadaval.",
        versionsChanged: "Versioonid muutusid muutmise ajal. Nimekiri laaditi uuesti.",
        forbidden: "Sul pole õigust selle dokumendi kõiki versioone muuta.",
        notFound: "Dokumenti ei leitud. Võimalik, et see on kustutatud.",
        notVersionable: "Selle dokumendi versioone ei saa siin muuta.",
        lastVersion: "Ajalukku peab jääma vähemalt üks versioon.",
        headInOtherProject:
          "See versioon asub teises projektis, seega ei saa sellest kehtivat versiooni teha.",
        pinned: "Kinnitatud fail ei saa oma kaustast lahkuda.",
        unknown: "Muudatusi ei õnnestunud salvestada. Palun proovi uuesti.",
      },
    },
    addNewVersion: {
      menuItem: "Lisa uus versioon",
      dialogTitle: "Lisa uued versioonid",
      dialogDescription: '"{filename}" on praegu v{version}.',
      dragDropFiles: "Lohista failid siia",
      dropFilesHere: "Kukuta failid siia",
      orClickToBrowse: "või kliki sirvimiseks",
      addMoreFiles: "Lisa veel faile",
      chooseFromDocuments: "Vali dokumentide hulgast",
      sortByName: "Sorteeri nime järgi",
      becomesCurrent: "Sellest saab praegune versioon",
      moveUp: "Liiguta üles",
      moveDown: "Liiguta alla",
      removeFile: "Eemalda",
      mismatchBadge: "Erinev nimi",
      mismatchTooltip: 'See failinimi ei vasta failile "{existing}". See lisatakse siiski.',
      blockedTitle: "Failitüüp pole lubatud",
      blockedDescription: "{count} fail(i) lükati tagasi, sest nende tüüp pole lubatud.",
      confirmNone: "Pole midagi lisada",
      confirmSingle: "Lisa 1 versioon",
      confirmMany: "Lisa {count} versiooni",
      adding: "Lisan…",
      fromProject: "Projektist {project}",
      versionChip: "v{version}",
      modeLabel: "Kuidas see dokument lisada",
      modeMove: "Teisalda",
      modeCopy: "Kopeeri",
      moveHintSingle: "Teisaldab dokumendi siia",
      moveHintMany: "Teisaldab kõik {count} versiooni siia",
      copyHint: "Lisab koopia; originaal jääb oma kohale",
      moveDisabledOlderVersion:
        "Teisaldada saab ainult praegust versiooni — teisaldamisel liigub kaasa kogu ajalugu.",
      moveDisabledDuplicate: "Selle dokumendi ajalugu on juba nimekirjas.",
      crossProjectMoveWarning:
        "See dokument asub projektis {project}. Selle kommentaaride ülesanded jäävad sinna ja joonisele kinnitatud ülesanded eemaldatakse joonise pealt.",
      checkingHistory: "Kontrollin ajalugu…",
      historyFailed: "Selle dokumendi ajalugu ei õnnestunud lugeda. Eemalda see ja proovi uuesti.",
      pickerTitle: "Vali lisatavad dokumendid",
      pickerDescription:
        "Vali selle hoone mis tahes projektist. Varasema versiooni valimiseks ava dokumendi ajalugu.",
      pickerSubmit: "Lisa nimekirja",
      pickerTargetLineage: "On juba selle dokumendi ajaloos",
      pickerAlreadyAdded: "Nimekirjas",
      toastSuccessTitle: "Uus versioon lisatud",
      toastSuccessDescription: '"{filename}" salvestati versioonina v{version}.',
      toastMovedDescription: '"{filename}" ja selle ajalugu lisati versioonidena v{first}–v{last}.',
      toastMovedSingleDescription: '"{filename}" teisaldati siia versioonina v{version}.',
      toastCopiedDescription: 'Dokumendi "{filename}" koopia lisati versioonina v{version}.',
      toastBatchSuccessTitle: "Uued versioonid lisatud",
      toastBatchSuccessDescription: "{count} uut versiooni lisatud — v{first} kuni v{last}.",
      toastPartialFailureTitle: "Peatus poole pealt",
      toastPartialFailureDescription:
        'Peatuti kohal "{filename}". {count} varasemat üksust lisati ja need on puutumata; ülejäänud on nimekirjas alles, et saaksid uuesti proovida.',
      toastRenamedTitle: "Nimi muudeti kattuvuse vältimiseks",
      toastRenamedDescription:
        '"{from}" salvestati nimega "{to}", sest selles kaustas on juba sama nimega dokument.',
      toastCrossProjectTitle: "Teisaldati teisest projektist",
      toastDetachedDescription: "Selle kommentaaride ülesanded jäävad projekti, kust see tuli.",
      toastAnchorsRemovedDescription:
        "{count} joonisele kinnitatud ülesannet eemaldati joonise pealt.",
      errorNoVersionGroup:
        "Sellel dokumendil puudub versioonigrupp — uut versiooni ei saa lisada. Proovi fail tavapäraselt uuesti üles laadida.",
      errorNoProject: "Dokumendil puudub projekti kontekst — uut versiooni ei saa lisada.",
      errors: {
        unavailable:
          "Olemasolevate dokumentide lisamine versioonidena pole veel saadaval. Faile saad endiselt üles laadida.",
        forbiddenSource: "Sul pole õigust seda dokumenti teisaldada.",
        forbiddenTarget: "Sul pole õigust sellele dokumendile versioone lisada.",
        sameLineage: "See dokument on juba selle dokumendi ajaloos.",
        differentBuilding: "Lisada saab ainult sama hoone dokumente.",
        sourceNotFound: "See dokument pole enam saadaval.",
        targetNotFound: "See dokument pole enam saadaval.",
        targetNotVersionable: "Sellele dokumendile ei saa uusi versioone lisada.",
        sourceIsChild: "Teise dokumendi sees olevat faili ei saa eraldi lisada.",
        containerCrossProject:
          "Sellel arhiivil on oma kaustad ja seda ei saa teise projekti teisaldada. Kopeeri see hoopis.",
        pinned: "Seda faili ei saa kaustast eemaldada. Kopeeri see hoopis.",
        unknown: "Dokumendi lisamisel läks midagi valesti.",
      },
    },
    history: {
      modalTitle: "Versiooniajalugu",
      viewFullHistory: "Vaata kogu ajalugu",
      current: "Praegune",
      empty: "Versioone ei leitud",
      loadError: "Versiooniajaloo laadimine ebaõnnestus",
      close: "Sulge",
      fetchFailedTitle: "Versioonide laadimine ebaõnnestus",
      fetchFailedDescription: "Selle faili varasemaid versioone ei õnnestunud laadida.",
      compareHint: "Võrdlemiseks vali kaks versiooni",
      select: "Vali",
      selectAll: "Vali kõik versioonid",
      selectedCount: "Valitud: {count}",
      versionsCount: "Versioone: {count}",
    },
    toasts: {
      filesSkippedTitle: "Failid vahele jäetud",
      filesSkippedDescription: "{count} fail(i) jäeti failinime kokkulangevuse tõttu vahele.",
      identicalSkippedTitle: "Identsed failid vahele jäetud",
      identicalSkippedDescription:
        "{count} fail(i) on juba identse sisuga olemas — üleslaadimiseks pole midagi.",
    },
    preview: {
      unavailableTitle: "Eelvaade pole saadaval",
      versionUnavailable: "Selle faili versioon pole enam saadaval.",
      dwgNotConverted: "DWG-faili teisendamine pole veel lõppenud. Alam-PDF-i ei leitud.",
    },
  },
  organize: {
    button: "Korrasta",
    title: "Korrasta kausta",
    titleProject: "Korrasta projekti",
    description:
      "Franklin analüüsib selle kausta faile ja pakub välja uue alamkaustade struktuuri.",
    scopeLoose: "Ainult lahtised failid",
    scopeLooseHint:
      "Sorteeri {count} faili, mis asuvad otse selles kaustas. Olemasolevaid alamkaustu ei puututa.",
    scopeSubtree: "Kogu kaustapuu",
    scopeSubtreeHint:
      "Korrasta kõik {count} faili, sealhulgas {folders} olemasolevas alamkaustas olevad.",
    start: "Alusta analüüsi",
    startTags: "Jätka",
    loading: "Kausta korrastamise oleku kontrollimine…",
    loadingProposal: "Ettepaneku struktuuri laadimine…",
    queued: "Järjekorras — analüüsi algust oodatakse…",
    analyzing: "Kausta dokumente analüüsitakse… See võib võtta mõne minuti.",
    closeHint: "Võid selle akna sulgeda — Franklin annab teada, kui valmis saab.",
    inProgressPill: "Korrastamine…",
    reviewPill: "Vaata ettepanek üle",
    failedTitle: "Korrastamine ebaõnnestus",
    retry: "Proovi uuesti",
    cancel: "Tühista",
    reviewStats: "Liigutatavaid faile: {moves} · Kaustu: {folders} ({newFolders} uut)",
    newFolderBadge: "uus",
    existingFolderBadge: "olemasolev",
    keptFiles: "Jääb oma kohale: {count}",
    moveCount: "{selected} / {total} liigutamist valitud",
    expiryNote: "Ettepanek aegub {time}.",
    apply: "Rakenda",
    applying: "Rakendamine…",
    discard: "Loobu",
    appliedToast: "{moved} faili liigutati {folders} kausta.",
    skippedStaleWarning:
      "{count} faili jäeti vahele, sest need muutusid pärast ettepaneku koostamist.",
    expiredError: "Ettepanek on aegunud. Käivita analüüs uuesti.",
    alreadyRunning:
      "Selle kausta korrastamine on juba pooleli või ootab ülevaatust, võib-olla kolleegi oma. See tuleb enne lõpetada või sellest loobuda.",
    alreadyRunningProject:
      "Selle projekti mõnes kaustas on korrastamine juba pooleli. Lõpeta või loobu sellest enne või vali „Ainult lahtised failid“.",
    alreadyRunningWholeProject:
      "Kogu projekti hõlmav korrastamine on juba pooleli. Lõpeta või loobu sellest enne.",
    alreadyRunningParent:
      "Ülemkausta korrastamine hõlmab juba ka seda kausta. Lõpeta või loobu sellest enne.",
    alreadyRunningSubfolder:
      "Alamkaustas on korrastamine juba pooleli. Lõpeta või loobu sellest enne või vali „Ainult lahtised failid“.",
    startError: "Analüüsi käivitamine ebaõnnestus.",
    applyError: "Ettepaneku rakendamine ebaõnnestus.",
    cancelError: "Ettepanekust loobumine ebaõnnestus.",
    countsError: "Kausta failide arvu laadimine ebaõnnestus.",
    namesError: "Failinimede laadimine ebaõnnestus — kuvame failide numbrid.",
    requestError: "Kausta korrastamise oleku kontrollimine ebaõnnestus.",
    readyToast: "Kausta korrastamine on ülevaatamiseks valmis.",
    readyToastAction: "Vaata üle",
    additionalInstructions: "Lisajuhised",
    additionalInstructionsPlaceholder:
      'Valikuline — nt "hoia kõik fotod koos" või "kasuta kaustanimedes numbrilisi eesliiteid"',
    modeAgent: "Franklin otsustab",
    modeAgentHint: "Franklin loeb failid läbi ja pakub välja neile sobiva struktuuri.",
    modeTags: "Siltide järgi",
    modeTagsHint: "Rühmita dokumentidel juba olevate siltide järgi. Kohene ja täpne.",
    groupBy: "Rühmita",
    groupByHint: "Kaustad tekivad valitud järjekorras. Klõpsa sildil, et see lisada või eemaldada.",
    dimensionPosition: "{position}. tase",
    previewLabel: "Tekkiv struktuur",
    previewLoading: "Struktuuri koostamine…",
    previewEmpty: "Ühelgi neist failidest pole valitud silte, seega pole midagi liigutada.",
    previewError: "Struktuuri koostamine ebaõnnestus.",
    previewStats: "Liigutatavaid faile: {moves} · Kaustu: {folders}",
    tagCapWarning: "Nii tekiks {count} kausta, mis ületab {limit} kausta piiri. Eemalda üks tase.",
    ambiguousNote: "Mitu silti ühel tasemel, kasutati esimest: {count}",
    untaggedNote: "Failid, millel puudub mõne taseme silt, jäävad ülemisele tasemele.",
    tagSummary: "Rühmitatud: {dimensions}.",
    noDimensions: "Vali vähemalt üks silt, mille järgi rühmitada.",
    renameFolder: "Nimeta kaust ümber",
    previewFile: "Ava eelvaade",
    dropToKeep: "Lohista siia, et fail jääks oma kohale",
    renameInvalidEmpty: "Kaustal peab olema nimi.",
    renameInvalidTooLong: "Nimi peab olema lühem kui {max} tähemärki.",
    renameInvalidSlash: 'Kausta nimi ei tohi sisaldada märki "/".',
    renameInvalidDuplicate: "Samas kohas on juba sellise nimega kaust.",
    renamedBadge: "ümber nimetatud",
    pathLabel: "Korrastatav kaust",
    pathEllipsisTitle: "Peidetud kaustad: {names}",
    containerBlocked: "Kausta korrastamiseks väljuge sellest arhiivist.",
  },
  signedContainer: {
    signed: "Allkirjastatud",
    signedExternally: "Allkirjastatud väljaspool Franklinit",
    signatureIssue: "Allkirja probleem",
    containerType: "Allkirjastatud ümbrik (ASiC-E)",
    inContainerChip: "{ext} sees",
    showEnclosed: "Näita ümbrikus olevaid dokumente",
    extracting: "Failide lahtipakkimine...",
    panel: {
      eyebrow: "Allkirjade andmed",
      enclosedTitle: "Dokumendid",
      enclosedEmpty: "Franklinil pole andmeid selle kohta, mis selles ümbrikus on.",
      enclosedError: "Selle ümbriku dokumente ei õnnestunud laadida.",
      viewSignatures: "Vaata allkirju",
      inspectionChecking: "Allkirjade kontrollimine…",
      inspectionChecked: "Allkirjad on Dokobitiga kontrollitud.",
      inspectionCheckedAt: "Kontrollitud {date}",
      inspectionRetry: "Kontrolli uuesti",
      inspectionFailed: "Allkirju ei õnnestunud kontrollida. Proovi minuti pärast uuesti.",
      inspectionUnsupported: "Selle failitüübi allkirjade kontrollimine pole toetatud.",
      inspectionTooLarge: "Allkirju saab kontrollida kuni 20 MB suurustes failides.",
      noSignatures: "Selles failis ei leitud digiallkirju.",
      unknownSigner: "Allkirjastaja nimi pole saadaval",
      unknownTime: "Allkirjastamise aeg pole saadaval",
      timestampOn: "Allkirja ajatempel: {date}",
      fileType: "{type}-fail",
      signaturePassed: "Allkirja kontroll läbitud",
      signatureWarnings: "{count} valideerimise hoiatust",
      unsigned: "Digiallkirjad puuduvad",
      signaturesTitle: "Allkirjad",
      signaturesEmpty:
        "Franklinil pole selle ümbriku allkirjade andmeid — see allkirjastati väljaspool Franklinit või pole veel töödeldud.",
      signatureBroken: "Allkirja kontroll ebaõnnestus",
      fieldStatus: "Olek",
      fieldSignatures: "Allkirju",
      fieldSignaturesUnknown: "Andmed puuduvad",
      fieldSignedOn: "Allkirjastatud",
      signedOn: "Allkirjastatud {date}",
      openedFrom: "Avatud failist {document}, mis asub ümbrikus {container}.",
      sign: "Lisa allkiri",
      share: "Jaga",
      open: "Ava",
      download: "Laadi alla",
      close: "Sulge",
      loading: "Allkirja andmete laadimine...",
      loadError: "Selle ümbriku allkirjade andmeid ei õnnestunud laadida.",
      downloadFailed: "Allalaadimine ebaõnnestus. Palun proovi uuesti.",
      openFailed: "Dokumendi avamine ebaõnnestus. Palun proovi uuesti.",
    },
  },
};
